// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { formatCelular, formatCPF } from "helpers";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { useEffect, useState } from "react";
import { loadClientes } from "store/actions/clientes";
import { useSelector } from "react-redux";
import formatName from "helpers/formatName";
import dayjs from "dayjs";
import { Divider, Paper, Tooltip } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import { ActionAceceptedOuRejected } from "store/actions/clientes";
import AlertComponent from "components/AlertComponent";
import ModalComponent from "components/Modal";
import Loading from "components/Loading";
import {
  DoneOutline,
  HighlightOff,
  KeyboardArrowLeftOutlined,
  KeyboardArrowRightOutlined,
  PersonAddAlt,
  PersonOff,
  PersonOffOutlined,
} from "@mui/icons-material";
import * as types from "../../store/types/clientes";
import { ButtonComponent } from "layouts/campanhas/styles";
import MDButton from "components/MDButton";

function ClientesCancelados() {
  const { clientes, loading, page, per_page, total } = useSelector(
    (state) => state.clientes
  );

  const [filtro, setFiltro] = useState("");
  const [filtroAtualizado, setFiltroAtualizado] = useState("");
  const [resetPage, setResetPage] = useState(false);

  async function GetDataLoad() {
    const data = {
      page: resetPage ? 1 : page,
      per_page: per_page,
      filtro: filtroAtualizado,
      status: "C",
    };
    await loadClientes(data);
    setFiltroAtualizado("");
    setResetPage(false);
  }

  const navigatePages = (validations) => {
    dispatch({ type: types.CLIENTES_DATA_PAGE, payload: validations });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (filtro === "") {
        GetDataLoad(); // Se filtro está vazio, chama a função GetDataLoad diretamente
      } else {
        setFiltroAtualizado(filtro);
        setResetPage(true);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [filtro, page]);

  useEffect(() => {
    if (filtroAtualizado !== "") {
      GetDataLoad();
    }
  }, [filtroAtualizado, page, resetPage]);

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [typeMessage, setTypeMessage] = useState("");
  const [dataMessage, setDataMessage] = useState("");
  const [dataCancel, setDataCancel] = useState({});
  const [dataCencelModal, setDataCencelModal] = useState(false);

  async function ActionAccepted(data, status) {

    await ActionAceceptedOuRejected(data.id, status).then(async (res) => {
      await GetDataLoad();

      if (status.aceite) {
        setShowSuccessAlert(true);
        setTypeMessage("success");
        setDataMessage(`Cliente reativado com sucesso: ${data.nome}`);
        setTimeout(() => {
          setShowSuccessAlert(false);
          setTypeMessage("");
          setDataMessage("");
        }, 3000);
      } else {
        setShowSuccessAlert(true);
        setTypeMessage("error");
        setDataMessage(`Cliente removido: ${data.nome}`);
        setTimeout(() => {
          setShowSuccessAlert(false);
          setTypeMessage("");
          setDataMessage("");
        }, 3000);
      }
    });
  }

  const Author = ({ nome, cpf, empresa_nome }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {nome}
        </MDTypography>
        <MDTypography variant="caption">CPF: {cpf}</MDTypography> <br/>
        <MDTypography variant="caption">Empresa: {empresa_nome}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Contato = ({ email, celular }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography
        display="block"
        variant="caption"
        color="text"
        fontWeight="medium"
      >
        {email}
      </MDTypography>
      <MDTypography variant="caption">{celular}</MDTypography>
    </MDBox>
  );

  const columns = [
    { Header: "Data", accessor: "data", align: "left" },
    { Header: "Cliente", accessor: "nome", align: "left" },
    { Header: "Contato", accessor: "contato", align: "left" },
    {
      Header: "data de nascimento ",
      accessor: "data_nascimento",
      align: "center",
    },
    { Header: "Ação", accessor: "action", align: "center" },
  ];

  const styleBtn = {
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
  };

  const rows = clientes.map((item) => {
    return {
      nome: <Author nome={formatName(item.nome)} cpf={item.cpf} empresa_nome={item.empresa_nome} />,
      contato: (
        <Contato email={item.email} celular={formatCelular(item.celular)} />
      ),
      data: dayjs(item.updated_at).format("DD/MM/YYYY"),
      data_nascimento: dayjs(item.data_nascimento).format("DD/MM/YYYY"),
      action: (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Tooltip title="Reativar Cliente">
              <button
                style={{
                  ...styleBtn,
                  fontSize: 25,
                }}
                onClick={() => ActionAccepted(item, { aceite: true })}
              >
                <PersonAddAlt style={{ color: "#18bc36" }} />
              </button>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Exclusão Permanente">
              <button
                style={{
                  ...styleBtn,
                  fontSize: 25,
                  marginLeft: 15,
                }}
                onClick={() => ExcluirClienteDefinitivo(item)}
              >
                <PersonOffOutlined style={{ color: "#ff0505" }} />
              </button>
            </Tooltip>
          </div>
        </div>
      ),
    };
  });

  const styledBtnArrows = {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    border: "none",
    cursor: "pointer",
    backgroundColor: "transparent",
    fontFamily: "Poppins",
  };
  async function ExcluirClienteDefinitivo(data) {
    setDataCencelModal(true);
    setDataCancel(data);
  }

  return (
    <DashboardLayout>
      <Loading loading={loading} />
      <DashboardNavbar
        filtroNome="Buscar Cliente Pelo Nome"
        valueFiltro={filtro}
        onChangeFiltro={(e) => setFiltro(e.target.value)}
      />

      {showSuccessAlert && (
        <AlertComponent
          type={typeMessage}
          message={dataMessage}
          timeout={3000}
        />
      )}

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Clientes Cancelados
                </MDTypography>
              </MDBox>
              <Paper elevation={1} style={{ padding: 5 }}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />

                <div style={{ margin: 15 }}>
                  <div
                    style={{
                      marginRight: 30,
                      display: "flex",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexDirection: "row",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      {+page !== 1 && (
                        <button
                          style={styledBtnArrows}
                          onClick={() => navigatePages(+page - 1)}
                        >
                          <KeyboardArrowLeftOutlined /> Anterior{" "}
                        </button>
                      )}

                      {clientes?.length !== 0 && (
                        <button
                          style={{ ...styledBtnArrows, marginLeft: 20 }}
                          onClick={() => navigatePages(+page + 1)}
                        >
                          Próximo <KeyboardArrowRightOutlined />
                        </button>
                      )}
                    </div>
                    <p
                      style={{
                        fontSize: 14,
                        backgroundColor: "transparent",
                        fontFamily: "Poppins",
                      }}
                    >
                      Pagina {page} | Total de clientes {total}
                    </p>
                  </div>
                </div>
              </Paper>
            </Card>
          </Grid>
        </Grid>

        <ModalComponent width={500} open={dataCencelModal}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <MDTypography variant="h6" color="gray">
              Você tem certeza que gostaria de excluir o cliente?
            </MDTypography>
            <span>Atenção, esta ação não poderá ser revertida!</span>
            <Divider />
            <span>Cliente: {dataCancel && formatName(dataCancel.nome)}</span>
            <span>CPF: {dataCancel && formatCPF(dataCancel.cpf)}</span>
            <Divider />

            <MDButton
              onClick={() => [
                ActionAccepted(dataCancel, { cancel: true }),
                setDataCencelModal(false),
              ]}
              color="primary"
               >
              SIM, EXCLUIR!
            </MDButton>
            <br />
            <MDButton           
              onClick={() => setDataCencelModal(false)}
              color="secondary"
            >
              CANCELAR
            </MDButton>
          </div>
        </ModalComponent>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ClientesCancelados;
